/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getQuoteRequestDetails } from "api/services/quoteRequest";
import { useCustomQuery } from "hooks/useCustomQuery";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

type GetQuoteRequestDetailOptions = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetQuoteRequestDetails = (data: GetQuoteRequestDetailOptions): any =>
  useCustomQuery({
    queryKey: quoteRequestQueryKeys.quoteDetails(data.shipmentId),
    queryFn: data.queryFn
      ? data.queryFn
      : ({ signal }) => getQuoteRequestDetails(data.shipmentId, { signal }).then((res) => res.data),
    ...data.options,
  });
